(function () {
    'use strict';

    angular.module('components.warning', []);
})();